// import { Copy, ArrowRight, Layers } from "lucide-react";
// import { motion } from "framer-motion";
// export default function WhyWeStarted() {
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: { staggerChildren: 0.2, delayChildren: 0.1 },
//     },
//   };
//   const itemVariants = {
//     hidden: { opacity: 0, y: 30 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
//     },
//   };
//   return (
//     <section className="about_us_class_why_section">
//       <div className="about_us_class_why_container">
//         {/* Heading */}
//         <motion.div
//           initial={{ opacity: 0, y: 80 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true, amount: 0.4 }}
//           transition={{
//             duration: 1,
//             ease: [0.22, 1, 0.36, 1],
//           }}
//           className="about_us_class_why_heading_wrap relative"
//         >
//           <motion.div
//             animate={{
//               opacity: [0.3, 0.6, 0.3],
//               scale: [1, 1.1, 1],
//             }}
//             transition={{
//               duration: 6,
//               repeat: Infinity,
//               ease: "easeInOut",
//             }}
//             className="absolute inset-0 blur-3xl bg-blue-500/10 rounded-full"
//           />

//           <motion.h2
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true, margin: "-100px" }}
//             transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
//             className="about_us_class_why_heading"
//           >
//             Work became more digital, but not always more organized
//           </motion.h2>
//         </motion.div>
//         {/* Cards */}

//         <motion.div
//           variants={containerVariants}
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true, margin: "-100px" }}
//           className="about_us_class_why_grid relative"
//         >
//           <div className="hidden md:block absolute top-[60px] left-[16.66%] right-[16.66%] h-[1px] bg-slate-100 z-0" />
//           <div className="hidden md:block absolute top-[58px] left-[14%] right-[14%] h-[1px] bg-gradient-to-r from-transparent via-slate-200 to-transparent opacity-70 blur-[0.3px] z-0" />
//           {/* Card 1 */}
//           <motion.div variants={itemVariants}>
//             <motion.div className="about_us_class_why_card">
//               <motion.div
//                 animate={{
//                   x: [-8, 8, -8],
//                   y: [-6, 6, -6],
//                   rotate: [-12, -8, -12],
//                 }}
//                 transition={{
//                   duration: 4,
//                   repeat: Infinity,
//                   ease: "easeInOut",
//                 }}
//                 className="absolute w-12 h-12 bg-blue-50/80 rounded-xl"
//                 style={{ transform: "translateZ(20px)" }}
//               />
//               <div className="about_us_class_why_icon_box">
//                 <Copy size={24} />
//               </div>
//               <h3>Scattered Tools</h3>
//               <p>
//                 Messages in one app, files in another, updates lost in email
//                 threads. A recipe for dropped balls.
//               </p>
//             </motion.div>
//           </motion.div>
//           {/* Card 2 */}
//           <div className="about_us_class_why_card">
//             <div className="about_us_class_why_icon_box about_us_class_why_mid">
//               <ArrowRight size={28} />
//             </div>
//             <h3>The Breaking Point</h3>
//             <p>
//               Teams spend more time managing work than actually doing it. Chaos
//               becomes the default state.
//             </p>
//           </div>

//           {/* Card 3 */}
//           <div className="about_us_class_why_card">
//             <div className="about_us_class_why_icon_box about_us_class_why_dark">
//               <Layers size={32} />
//             </div>
//             <h3>Connected Workflow</h3>
//             <p>
//               Everything in one system. Tasks, files, conversations, and
//               approvals seamlessly connected.
//             </p>
//           </div>
//         </motion.div>
//       </div>
//     </section>
//   );
// }

import { Copy, ArrowRight, Layers } from "lucide-react";
import { motion } from "framer-motion";

export default function WhyWeStarted() {
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.18,
        delayChildren: 0.15,
      },
    },
  };

  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 80,
      scale: 0.92,
    },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 1,
        ease: [0.16, 1, 0.3, 1],
      },
    },
  };
  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
    },
  };
  return (
    <section className="about_us_class_why_section relative overflow-hidden py-32">
      {/* Ambient Background */}
      <motion.div
        animate={{
          scale: [1, 1.1, 1],
          opacity: [0.15, 0.25, 0.15],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-blue-500/10 blur-[140px] rounded-full"
      />

      <div className="about_us_class_why_container relative z-10">
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 70 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{
            duration: 1,
            ease: [0.22, 1, 0.36, 1],
          }}
          className="about_us_class_why_heading_wrap text-center mb-24"
        >
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: "120px" }}
            viewport={{ once: true }}
            transition={{
              delay: 0.4,
              duration: 1,
              ease: "easeOut",
            }}
            className="h-[4px] mx-auto mb-8 rounded-full bg-gradient-to-r from-blue-500 to-cyan-400"
          />

          <motion.h2
            initial={{ opacity: 0, letterSpacing: "8px" }}
            whileInView={{ opacity: 1, letterSpacing: "0px" }}
            viewport={{ once: true }}
            transition={{
              delay: 0.1,
              duration: 1,
              ease: [0.16, 1, 0.3, 1],
            }}
            className="about_us_class_why_heading"
          >
            Work became more digital, but not always more organized
          </motion.h2>
        </motion.div>

        {/* Cards */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative"
        >
          {/* Subtle Connecting Line */}
          <div className="hidden md:block absolute top-[60px] left-[16.66%] right-[16.66%] h-[1px] bg-slate-100 z-0" />

          {/* 1. Scattered Tools */}
          <motion.div variants={itemVariants}>
            <div
              className="w-[120px] h-[120px] rounded-[28px] bg-white shadow-[0_8px_30px_rgba(0,0,0,0.04)] border border-slate-100/60 flex items-center justify-center mb-8 relative mx-auto overflow-hidden"
              style={{ transformStyle: "preserve-3d" }}
            >
              {/* Animated Floating Elements */}
              <motion.div
                animate={{
                  x: [-8, 8, -8],
                  y: [-6, 6, -6],
                  rotate: [-12, -8, -12],
                }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="absolute w-12 h-12 bg-blue-50/80 rounded-xl"
                style={{ transform: "translateZ(20px)" }}
              />
              <motion.div
                animate={{
                  x: [8, -8, 8],
                  y: [6, -6, 6],
                  rotate: [12, 8, 12],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="absolute w-12 h-12 bg-amber-50/80 rounded-xl"
                style={{ transform: "translateZ(30px)" }}
              />
              <motion.div
                animate={{
                  scale: [1, 1.05, 1],
                  rotate: [0, 5, 0],
                }}
                transition={{
                  duration: 3,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="relative z-10 w-12 h-12 bg-white rounded-xl shadow-sm border border-slate-100 flex items-center justify-center"
                style={{ transform: "translateZ(50px)" }}
              >
                <Copy className="w-6 h-6 text-slate-500" />
              </motion.div>

              {/* Chaos indicator - subtle particles */}
              <motion.div
                animate={{
                  opacity: [0.3, 0.6, 0.3],
                  scale: [0.8, 1.2, 0.8],
                }}
                transition={{ duration: 2, repeat: Infinity }}
                className="absolute top-2 right-2 w-2 h-2 bg-red-400 rounded-full"
              />
            </div>
            <div className="text-center px-4">
              <h3 className="text-xl font-medium text-slate-900 mb-4">
                Scattered Tools
              </h3>
              <p className="firm_Class ">
                Messages in one app, files in another, updates lost in email
                threads. A recipe for dropped balls.
              </p>
            </div>
          </motion.div>

          {/* 2. The Breaking Point */}
          <motion.div variants={itemVariants}>
            <div
              className="w-[120px] h-[120px] rounded-[28px] bg-white shadow-[0_8px_30px_rgba(0,0,0,0.04)] border border-slate-100/60 flex items-center justify-center mb-8 relative mx-auto overflow-hidden"
              style={{ transformStyle: "preserve-3d" }}
            >
              {/* Pulsing warning rings */}
              <motion.div
                animate={{
                  scale: [1, 2, 1],
                  opacity: [0.5, 0, 0.5],
                }}
                transition={{ duration: 2, repeat: Infinity }}
                className="absolute w-16 h-16 border-2 border-amber-300 rounded-full"
              />
              <motion.div
                animate={{
                  scale: [1, 2, 1],
                  opacity: [0.5, 0, 0.5],
                }}
                transition={{ duration: 2, delay: 0.5, repeat: Infinity }}
                className="absolute w-16 h-16 border-2 border-amber-300 rounded-full"
              />

              {/* Animated arrow */}
              <motion.div
                animate={{
                  x: [-10, 10, -10],
                  opacity: [0.5, 1, 0.5],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="relative z-10"
                style={{ transform: "translateZ(40px)" }}
              >
                <ArrowRight
                  className="w-8 h-8 text-slate-400"
                  strokeWidth={1.5}
                />
              </motion.div>
            </div>
            <div className="text-center px-4">
              <h3 className="text-xl font-medium text-slate-900 mb-4">
                The Breaking Point
              </h3>
              <p className="firm_Class">
                Teams spend more time managing work than actually doing it.
                Chaos becomes the default state.
              </p>
            </div>
          </motion.div>

          {/* 3. Connected Workflow */}
          <motion.div variants={itemVariants}>
            <div
              className="w-[120px] h-[120px] rounded-[28px] bg-[#0F172A] shadow-[0_20px_40px_rgba(15,23,42,0.15)] flex items-center justify-center mb-8 relative mx-auto group overflow-hidden"
              style={{ transformStyle: "preserve-3d" }}
            >
              {/* Animated inner glow */}
              <motion.div
                animate={{
                  opacity: [0.3, 0.6, 0.3],
                  scale: [0.95, 1.05, 0.95],
                }}
                transition={{
                  duration: 3,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="absolute inset-0 bg-gradient-to-tr from-blue-500/20 via-emerald-500/10 to-transparent rounded-[28px]"
              />

              {/* Success particles */}
              {[0, 1, 2, 3].map((i) => (
                <motion.div
                  key={i}
                  animate={{
                    y: [0, -40],
                    opacity: [0, 1, 0],
                    scale: [0, 1, 0.5],
                  }}
                  transition={{
                    duration: 2,
                    delay: i * 0.5,
                    repeat: Infinity,
                    ease: "easeOut",
                  }}
                  className="absolute bottom-10 w-1.5 h-1.5 bg-emerald-400 rounded-full"
                  style={{ left: `${30 + i * 15}%` }}
                />
              ))}

              {/* Animated icon */}
              <motion.div
                animate={{
                  scale: [1, 1.1, 1],
                  rotate: [0, 360],
                }}
                transition={{
                  scale: { duration: 2, repeat: Infinity, ease: "easeInOut" },
                  rotate: { duration: 20, repeat: Infinity, ease: "linear" },
                }}
                className="relative z-10"
                style={{ transform: "translateZ(50px)" }}
              >
                <Layers className="w-10 h-10 text-white" strokeWidth={1.5} />
              </motion.div>
            </div>
            <div className="text-center px-4">
              <h3 className="text-xl font-medium text-slate-900 mb-4">
                Connected Workflow
              </h3>
              <p className="firm_Class">
                Everything in one system. Tasks, files, conversations, and
                approvals seamlessly connected.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
